/**
 * Initialize <i>node</i> as wrapper for DocumentDragAndDrop.
 * Use this with <i>new</i>.
 * Use <i>node.DD.add</i> to add some fields.
 * Overrides <i>document.onkeydown</i>.
 * @param {Element} node
 * @returns {undefined}
 */
function DocumentDragAndDrop(node) {
  /* ---- document controll ---- */

  //create wrapper
  var documentControll = document.createElement("div");
  documentControll.classList.add("document-controll");

  //create buttons
  var buttonsHTML =
    '<i class="material-icons">save</i>' +
    '<i class="material-icons">delete</i>' +
    '<i class="material-icons">history</i>' +
    '<i class="material-icons">translate</i>';
  documentControll.insertAdjacentHTML("afterbegin", buttonsHTML);

  //append controll to DOM
  node.appendChild(documentControll);

  /* ---- add new page ---- */

  //create wrapper
  var documentControll = document.createElement("div");
  documentControll.classList.add("document-add-a4");

  //create buttons
  var addPageHTML = '<i class="material-icons">note_add</i>';
  documentControll.insertAdjacentHTML("afterbegin", addPageHTML);

  //append controll to DOM
  node.appendChild(documentControll);

  /* ---- holders ---- */
  var STICKY_GAPE = 15;

  //move holders with arrow keys
  document.onkeydown = function (event) {
    //remove this if node is not more in DOM
    var nodeBoundings = node.getBoundingClientRect();
    if (
      nodeBoundings.left === 0 &&
      nodeBoundings.right === 0 &&
      nodeBoundings.top === 0 &&
      nodeBoundings.bottom === 0 &&
      nodeBoundings.width === 0 &&
      nodeBoundings.height === 0
    ) {
      document.onkeydown = null;
      return;
    }

    //get moving direction
    var moveX = null;
    var moveY = null;
    switch (event.which) {
      case 38: //up
        moveY = -1;
        break;
      case 40: //down
        moveY = 1;
        break;
      case 37: //left
        moveX = -1;
        break;
      case 39: //right
        moveX = 1;
        break;
      default:
        return;
    }

    //get nodes to be moved
    var nodeChildren = node.children;
    var holderToMove = [];
    for (var i = 0, len = nodeChildren.length; i < len; i++) {
      var holder = nodeChildren[i];
      if (holder.classList.contains("is-draggable")) holderToMove.push(holder);
    }

    if (holderToMove.length === 0) return;

    //only prevent default if user want to move something
    event.preventDefault();

    //split code here for avoid multiple checking on moveX and moveY
    if (moveX !== null) {
      //check min and max boundings
      for (var i = 0, len = holderToMove.length; i < len; i++) {
        var holder = holderToMove[i];
        var holderLeft = parseInt(holder.style.left);
        var holderWidth = parseInt(holder.style.width);
        if (
          (holderLeft <= 0 && moveX === -1) ||
          (holderLeft + holderWidth >= nodeBoundings.width && moveX === 1)
        )
          return;
      }

      //set new position
      for (var i = 0, len = holderToMove.length; i < len; i++) {
        var holder = holderToMove[i];
        holder.style.left = parseInt(holder.style.left) + moveX + "px";
      }
    } else if (moveY !== null) {
      //check min and max boundings
      for (var i = 0, len = holderToMove.length; i < len; i++) {
        var holder = holderToMove[i];
        var holderTop = parseInt(holder.style.top);
        var holderHeight = parseInt(holder.style.height);
        if (
          (holderTop <= 0 && moveY === -1) ||
          (holderTop + holderHeight >= nodeBoundings.height && moveY === 1)
        )
          return;
      }

      //set new position
      for (var i = 0, len = holderToMove.length; i < len; i++) {
        var holder = holderToMove[i];
        holder.style.top = parseInt(holder.style.top) + moveY + "px";
      }
    }
  };

  node.DD = {
    add: {
      /**
       * Creates generic item holder with standard functions like, positioning, resizing, removing and so on.
       * @param {object} options
       * Something like <i>{data: {}, meta: {height:40, left:100, top:100, width:130, zIndex:0}}</i>
       * @returns {Element}
       */
      _createGenericHolder: function (options) {
        //default options
        var defaultmeta = {
          height: 48,
          width: 180,
          top: 100,
          left: 100,
          zIndex: 0,
        };
        var metaToApply = defaultmeta;
        //use this to make all options optional
        var meta = options.meta;
        for (var i in meta) metaToApply[i] = meta[i];

        //create new item
        var holder = document.createElement("div");
        holder.classList.add("item-holder");

        //add item menu
        //if you change this, update event listener indexes
        var naviHtml =
          '<div class="naviOptions">' +
          '<i class="material-icons">edit</i>' +
          '<i class="material-icons">done</i>' +
          '<i class="material-icons">delete</i>' +
          '<i class="drag material-icons">gamepad</i>' +
          '<i class="resize material-icons">crop</i>' +
          '<i class="zIndex material-icons">layers</i>' +
          '<i class="material-icons">content_copy</i>' +
          '<i class="history material-icons">history</i>' +
          "</div>" +
          '<div class="sticky-drag sticky-drag-top"></div>' +
          '<div class="sticky-drag sticky-drag-left"></div>' +
          '<div class="resize resize-right"></div>' +
          '<div class="resize resize-bottom"></div>' +
          '<div class="sticky-resize sticky-resize-width"></div>' +
          '<div class="sticky-resize sticky-resize-height"></div>' +
          '<div class="remove-question">' +
          '<label class="question">Entfernen?</label>' +
          '<label class="answer ok">Ja</label>' +
          '<label class="answer no">Nein</label>' +
          "</div>" +
          '<div class="zIndex">' +
          '<button class="add">+</button>' +
          '<input type="number" value="' +
          metaToApply.zIndex +
          '">' +
          '<button class="sub">-</button>' +
          "</div>" +
          '<div class="history"></div>' +
          '<div class="translate"></div>';
        holder.insertAdjacentHTML("beforeend", naviHtml);

        //apply options
        holder.style.height = metaToApply.height + "px";
        holder.style.width = metaToApply.width + "px";
        holder.style.top = metaToApply.top + "px";
        holder.style.left = metaToApply.left + "px";
        holder.style.zIndex = metaToApply.zIndex;

        //add functions
        holder.DD = {
          _history: options.history ? options.history : [],
          remove: function () {
            var that = holder;
            that.parentNode.removeChild(that);
          },
          getMeta: function () {
            var that = holder;
            var style = that.style;
            return {
              width: parseInt(style.width),
              height: parseInt(style.height),
              top: parseInt(style.top),
              left: parseInt(style.left),
              zIndex: parseInt(style.zIndex),
            };
          },
          _save: function () {
            var historyItem = this.get();
            historyItem.description = new Date().toLocaleDateString();

            //add history item to front of list
            this._history.unshift(historyItem);
          },
          restore: function (options) {
            //apply generic
            holder.style.height = options.meta.height + "px";
            holder.style.width = options.meta.width + "px";
            holder.style.top = options.meta.top + "px";
            holder.style.left = options.meta.left + "px";
            holder.style.zIndex = options.meta.zIndex;

            //restore data in custom implementation
            holder.DD.restoreData(options);
          },
        };

        // ---- event listener start ----
        var naviElements = holder.children[0].children;

        //edit
        naviElements[0].addEventListener("click", function () {
          holder.classList.add("is-active");
        });

        //done
        naviElements[1].addEventListener("click", function () {
          holder.classList.remove("is-active");
          holder.classList.remove("is-draggable");
          holder.classList.remove("is-resizeable");
          holder.classList.remove("is-removeable");
          holder.classList.remove("is-zIndex");
          holder.classList.remove("is-history");
          node.DD._clear.removeSticky();
          holder.DD._save();
        });

        //remove/clear
        naviElements[2].addEventListener("click", function () {
          holder.classList.remove("is-resizeable");
          holder.classList.remove("is-draggable");
          holder.classList.remove("is-zIndex");
          holder.classList.remove("is-history");
          holder.classList.toggle("is-removeable");
          node.DD._clear.removeSticky();
        });
        //remove ok
        holder
          .querySelector(".remove-question .ok")
          .addEventListener("click", function () {
            holder.DD.remove();
          });
        //remove no
        holder
          .querySelector(".remove-question .no")
          .addEventListener("click", function () {
            holder.classList.remove("is-removeable");
          });

        //drag/gamepad
        naviElements[3].addEventListener("click", function () {
          holder.classList.remove("is-resizeable");
          holder.classList.remove("is-removeable");
          holder.classList.remove("is-zIndex");
          holder.classList.remove("is-history");
          holder.classList.toggle("is-draggable");
          node.DD._clear.removeSticky();
        });
        holder.addEventListener("mousemove", function (event) {
          event.preventDefault();

          //only if mouse is down
          if (event.which === 0 || !this.classList.contains("is-draggable"))
            return;

          //ignore some drags after stick
          if (this.dataset.dragSticked !== undefined) {
            this.dataset.dragSticked = parseInt(this.dataset.dragSticked) - 1;

            if (parseInt(this.dataset.dragSticked) <= 0)
              delete this.dataset.dragSticked;
            return;
          }

          //calculate new position by move direction
          var top = parseInt(this.style.top) + event.movementY;
          var left = parseInt(this.style.left) + event.movementX;

          //calculate bounds
          top = Math.max(top, 0);
          left = Math.max(left, 0);
          var nodeBounds = node.getBoundingClientRect();
          var holderBounds = this.getBoundingClientRect();
          top = Math.min(top, nodeBounds.height - holderBounds.height);
          left = Math.min(left, nodeBounds.width - holderBounds.width);

          //check for other holder with near coordinates
          var allHolder = node.children;
          var stickyFoundX = false;
          var stickyFoundY = false;
          for (var i = 0, len = allHolder.length; i < len; i++) {
            var otherHolder = allHolder[i];

            if (otherHolder === holder) continue;

            var otherLeft = parseInt(otherHolder.style.left);
            var otherTop = parseInt(otherHolder.style.top);

            //check X
            //do not search for new sticky if a sticky already found
            if (!stickyFoundX) {
              var oldXDistance = Math.abs(
                parseInt(this.style.left) - otherLeft
              );
              var newXDistance = Math.abs(left - otherLeft);

              if (newXDistance < oldXDistance && newXDistance <= STICKY_GAPE) {
                left = otherLeft;
                this.dataset.dragSticked = 5;
              }
            }

            //check Y
            //do not search for new sticky if a sticky already found
            if (!stickyFoundY) {
              var oldYDistance = Math.abs(parseInt(this.style.top) - otherTop);
              var newYDistance = Math.abs(top - otherTop);

              if (newYDistance < oldYDistance && newYDistance <= STICKY_GAPE) {
                top = otherTop;
                this.dataset.dragSticked = 5;
              }
            }

            //highlight all other holder with the same position
            if (otherLeft === left)
              otherHolder.classList.add("is-sticky-drag-left");
            else otherHolder.classList.remove("is-sticky-drag-left");

            if (otherTop === top)
              otherHolder.classList.add("is-sticky-drag-top");
            else otherHolder.classList.remove("is-sticky-drag-top");
          }

          //apply new position
          this.style.top = top + "px";
          this.style.left = left + "px";
        });

        //crop/resize
        naviElements[4].addEventListener("click", function () {
          holder.classList.remove("is-draggable");
          holder.classList.remove("is-removeable");
          holder.classList.remove("is-zIndex");
          holder.classList.remove("is-history");
          holder.classList.toggle("is-resizeable");
          node.DD._clear.removeSticky();
        });
        //resize X
        holder.children[3].addEventListener("mousemove", function (event) {
          event.preventDefault();

          //only if mouse is down
          if (event.which === 0 || !holder.classList.contains("is-resizeable"))
            return;

          //ignore some drags after stick
          if (holder.dataset.widthSticked !== undefined) {
            holder.dataset.widthSticked =
              parseInt(holder.dataset.widthSticked) - 1;

            if (parseInt(holder.dataset.widthSticked) <= 0)
              delete holder.dataset.widthSticked;
            return;
          }

          //calculate width
          var width = holder.getBoundingClientRect().width + event.movementX;
          width = Math.max(width, 0);
          width = Math.min(width, node.getBoundingClientRect().width);

          //check for other holder with near width
          var allHolder = node.children;
          var stickyFound = false;
          for (var i = 0, len = allHolder.length; i < len; i++) {
            var otherHolder = allHolder[i];

            //check X
            var otherWidth = parseInt(
              otherHolder.getBoundingClientRect().width
            );

            //only search for sticky if no other found yet
            if (!stickyFound) {
              var oldXDifference = Math.abs(
                parseInt(holder.style.width) - otherWidth
              );
              var newXDifference = Math.abs(width - otherWidth);

              if (
                newXDifference < oldXDifference &&
                newXDifference <= STICKY_GAPE
              ) {
                width = otherWidth;
                holder.dataset.widthSticked = 5;
                stickyFound = true;
              }
            }

            //highlight all other holder with the same width
            if (otherWidth === width)
              otherHolder.classList.add("is-sticky-resize-width");
            else otherHolder.classList.remove("is-sticky-resize-width");
          }

          //apply new width
          holder.style.width = width + "px";
        });
        //resize Y
        holder.children[4].addEventListener("mousemove", function (event) {
          event.preventDefault();

          //only if mouse is down
          if (event.which === 0 || !holder.classList.contains("is-resizeable"))
            return;

          //ignore some drags after stick
          if (holder.dataset.heightSticked !== undefined) {
            holder.dataset.heightSticked =
              parseInt(holder.dataset.heightSticked) - 1;

            if (parseInt(holder.dataset.heightSticked) <= 0)
              delete holder.dataset.heightSticked;
            return;
          }

          //calculate width
          var height = holder.getBoundingClientRect().height + event.movementY;
          height = Math.max(height, 0);
          height = Math.min(height, node.getBoundingClientRect().height);

          //check for other holder with near height
          var allHolder = node.children;
          var stickyFound = false;
          for (var i = 0, len = allHolder.length; i < len; i++) {
            var otherHolder = allHolder[i];

            //check X
            var otherHeight = parseInt(
              otherHolder.getBoundingClientRect().height
            );

            //only search for sticky if no other found yet
            if (!stickyFound) {
              var oldXDifference = Math.abs(
                parseInt(holder.style.height) - otherHeight
              );
              var newXDifference = Math.abs(height - otherHeight);

              if (
                newXDifference < oldXDifference &&
                newXDifference <= STICKY_GAPE
              ) {
                height = otherHeight;
                holder.dataset.heightSticked = 5;
                stickyFound = true;
              }
            }

            //highlight all other holder with the same height
            if (otherHeight === height)
              otherHolder.classList.add("is-sticky-resize-height");
            else otherHolder.classList.remove("is-sticky-resize-height");
          }

          //apply new width
          holder.style.height = height + "px";
        });

        //zIndex/layer
        naviElements[5].addEventListener("click", function () {
          holder.classList.remove("is-draggable");
          holder.classList.remove("is-removeable");
          holder.classList.remove("is-resizeable");
          holder.classList.remove("is-history");
          holder.classList.toggle("is-zIndex");
          node.DD._clear.removeSticky();
        });
        var zIndexInput = holder.querySelector(".zIndex input");
        holder
          .querySelector(".zIndex button.add")
          .addEventListener("click", function () {
            var value = parseInt(zIndexInput.value);
            value++;
            value = Math.min(value, 100);
            zIndexInput.value = value;
            holder.style.zIndex = value;
          });
        holder
          .querySelector(".zIndex button.sub")
          .addEventListener("click", function () {
            var value = parseInt(zIndexInput.value);
            value--;
            value = Math.max(value, 0);
            zIndexInput.value = value;
            holder.style.zIndex = value;
          });
        holder
          .querySelector(".zIndex input")
          .addEventListener("keyup", function () {
            var value = parseInt(this.value);
            value = Math.max(value, 0);
            value = Math.min(value, 100);
            holder.style.zIndex = value;
          });

        //copy
        naviElements[6].addEventListener("click", function () {
          var data = holder.DD.get();

          //copy object
          data = JSON.parse(JSON.stringify(data));

          //check if constructor exists
          var addFunction = node.DD.add[data.type];
          if (typeof addFunction !== "function") {
            console.error(data.meta.type + " could not be build");
            return;
          }

          //move holder to show difference
          data.meta.left += 100;
          data.meta.top += 100;
          data.meta.zIndex++;

          //could not use var addFunction because of the context
          node.DD.add[data.type](data);
        });

        //history
        naviElements[7].addEventListener("click", function () {
          holder.classList.remove("is-draggable");
          holder.classList.remove("is-removeable");
          holder.classList.remove("is-resizeable");
          holder.classList.remove("is-zIndex");
          holder.classList.toggle("is-history");
          node.DD._clear.removeSticky();

          //fill history node content here to avoid unnecessary elements
          var historyWrapper = holder.querySelector("div.history");

          //clear list
          historyWrapper.innerHTML = null;

          var history = holder.DD._history;

          //if history empty, show hint
          if (history.length === 0) {
            historyWrapper.insertAdjacentHTML(
              "afterbegin",
              '<li class="empty">Leer</li>'
            );
            return;
          }

          //draw found history enties
          var html = "";
          for (var i = 0, len = history.length; i < len; i++) {
            var historyItem = history[i];
            html += "<li>" + historyItem.description + "</li>";
          }
          historyWrapper.insertAdjacentHTML("afterbegin", html);

          var historyWrapperChildren = historyWrapper.children;
          for (var i = 0, len = historyWrapperChildren.length; i < len; i++) {
            historyWrapperChildren[i].addEventListener("click", clickHandler);
            historyWrapperChildren[i].addEventListener(
              "mouseover",
              hoverHandler
            );
            historyWrapperChildren[i].addEventListener(
              "mouseout",
              hoveroutHandler
            );
          }

          //store current status without saving
          var currentStatus = holder.DD.get();

          /**
           * Apply history item data and meta.
           * Also apply to <i>currentStatus</i>.
           */
          function clickHandler() {
            //get index of historyItem
            var index = Array.prototype.indexOf.call(
              this.parentNode.children,
              this
            );

            var statusToRestore = holder.DD._history[index];

            //restore data and meta
            holder.DD.restore(statusToRestore);

            currentStatus = statusToRestore;
          }

          /**
           * Restore data only to preview history items content.
           * @param {Event} event
           */
          function hoverHandler(event) {
            event.preventDefault();

            //get index of historyItem
            var index = Array.prototype.indexOf.call(
              this.parentNode.children,
              this
            );

            //restore only data
            holder.DD.restoreData(holder.DD._history[index]);
            holder.classList.add("is-history-preview");
          }

          /**
           * On mouse out restore to <i>currentStatus</i> back.
           * @param {Event} event
           */
          function hoveroutHandler(event) {
            event.preventDefault();

            holder.DD.restoreData(currentStatus);
            holder.classList.remove("is-history-preview");
          }
        });

        // ---- event listener end ----

        return holder;
      },
      /**
       * Adds a multiline text input to <i>node</i>
       * @param {object} options
       * Something like <i>{data: {text: 'hi'}, meta: {height:40, left:100, top:100, width:130, zIndex:0}}</i>
       * @returns {undefined}
       */
      simpleMultilineText: function (options) {
        var that = node;

        if (typeof options === "undefined")
          options = {
            meta: {},
            data: {},
            history: [],
          };

        //create holder
        var holder = this._createGenericHolder(options);
        holder.classList.add("simpleMultiLineText");

        //create textarea
        var textarea = document.createElement("textarea");
        textarea.value = options.data.text ? options.data.text : null;
        holder.appendChild(textarea);

        //append functions
        holder.DD.get = function () {
          return {
            type: "simpleMultilineText",
            meta: holder.DD.getMeta(),
            data: {
              text: textarea.value,
            },
          };
        };
        holder.DD.restoreData = function (options) {
          textarea.value = options.data.text;
        };

        //add holder to DOM
        that.appendChild(holder);
      },
    },
    /**
     * Some getter functions
     */
    get: {
      /**
       * Collects data from all item holders
       * @returns {Array}
       * Array with objects like <i>{data: {text: 'hi'}, meta: {height:40, left:100, top:100, width:130, zIndex:0}}</i>
       */
      all: function () {
        var children = node.children;

        var result = [];

        for (var i = 0, len = children.length; i < len; i++)
          result.push(children[i].DD.get());

        return result;
      },
    },
    /**
     *
     * @param {type} name
     */
    save: function (name) {
      //get all data
      var itemToStore = this.get.all();

      //add name to data set
      itemToStore.name = name;

      //id will be generated on server
      itemToStore.id = null;

      //add on top
      this._history.unshift(itemToStore);
    },
    _history: [],
    _clear: {
      /**
       * Removes sticky marker from all holders.
       */
      removeSticky: function () {
        var allHolder = node.children;
        for (var i = 0, len = allHolder.length; i < len; i++) {
          var holder = allHolder[i];
          holder.classList.remove("is-sticky-resize-width");
          holder.classList.remove("is-sticky-resize-height");
          holder.classList.remove("is-sticky-drag-top");
          holder.classList.remove("is-sticky-drag-left");
        }
      },
    },
  };
}
